import { useMemo } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { ActionsColumn, selectableColumns, Questions } from './columns'
import { useRequirementDetailContextValue } from '../../context/RequirementDetailProvider'

export const useSelectedColumns = (): ColumnDef<Questions[number]>[] => {
  const {
    state: { questions },
  } = useRequirementDetailContextValue()

  const columnsToDisplay = useMemo(() => {
    return [
      ...selectableColumns.map((column) => column.columnDef),
      ActionsColumn,
    ]
  }, [questions])

  return columnsToDisplay
}
